import { Injectable } from '@angular/core';
import { Observable, of as observableOf} from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { tap } from 'rxjs/operators';
import { Actions, createEffect, ofType, Effect } from '@ngrx/effects';
import * as AuthActions from './auth.actions';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog'
import { PopupMessageComponent } from 'src/app/modules/ifa/popup-message/popup-message.component';

@Injectable()
export class AuthEffect {
    constructor(
        private actions$ : Actions,
        private authService : AuthService,
        private router: Router,
        private dialog:MatDialog,
        ){ }

    @Effect()
    Login$: Observable<any> = this.actions$.pipe(
      ofType(AuthActions.Login),
      switchMap((payload : any) => {
        return this.authService
          .loginUser(payload.data)
          .pipe(
            map((response: any) => {
              if (response != null && response.token) {
                // console.log('LogIn', response);                
                return AuthActions.LoginSuccess({response : response});
              }
               else {
                return AuthActions.LoginFailure({
                  error: {error : 'Incorrect email and/or password.'},
                });
              }
            }),
            catchError((error) => {
              // console.log('LogIn', error);
              return observableOf(AuthActions.LoginFailure({ error: error }));
            })
          );
      })
    );
    
    @Effect()
    GenerateOTP$: Observable<any> = this.actions$.pipe(
      ofType(AuthActions.GenerateOTP),
      switchMap((payload : any) => {
        return this.authService
          .generateOTP(payload.mobileOrEmail, payload.userType)
          .pipe(
            map((response: any) => {
              if (response != null && response.status == 'OK') {  
                this.authService.showOTP.next(true);              
                return AuthActions.OTPSuccess({response : response});
              }
              else {
                this.authService.showOTP.next(false);
                return AuthActions.OTPFailure({
                  error: response,
                });
              }
            }),
            catchError((error) => {
              // console.log('OTP generate', error);
              return observableOf(AuthActions.OTPFailure({ error: error }));
            })
          );
      })
    );

    @Effect()
    VerifyOTP$: Observable<any> = this.actions$.pipe(
      ofType(AuthActions.VerifyOTP),
      switchMap((payload : any) => {
        return this.authService
          .verifyOTP(payload.phone, payload.otp, payload.userType,payload.ref_code)
          .pipe(
            map((response: any) => {
              if (response != null && response.status == 'OK') {                
                return AuthActions.VerifyOTPSuccess({response : response});
              }
              else if (response != null && response.status == 'FAIL' && response.message == 'User not Registered')
              {
              
                const popup = this.dialog.open(PopupMessageComponent,{
                  data:{
                    title:"newUserRegi",
                      message: response.message
                    }
                  });
                  popup.afterOpened().subscribe((res : any)=>{
                    setTimeout(()=>{
                      popup.close();
                    },10000);
                    window.location.reload();
                  })
                 
                return true;
              }
              else {
                return AuthActions.VerifyOTPFailure({
                  error: response,
                });
              }
            }),
            catchError((error) => {
              // console.log('OTP generate', error);
              return observableOf(AuthActions.VerifyOTPFailure({ error: error }));
            })
          );
      })
    );

}